import { Box, Card, Grid } from "@mui/material";
import React from "react";
import ComponentPenunjang from "../Components/ComponentPenunjang";
import KneeXImg from "../../../assets/images/knee_xray.svg";
import PillsImg from "../../../assets/images/pills.png";
import LabsImg from "../../../assets/images/lab.jpg";
import HistoryObat from "../Components/HistoryObat";
import HistoryLaboratorium from "../Components/HistoryLaboratorium";
import HistoryRadiologi from "../Components/HistoryRadiologi";

type Props = {};

const TemplatePenunjang = (props: Props) => {
  const [open, setOpen] = React.useState({
    obat: false,
    laboratorium: false,
    radiologi: false,
  });
  return (
    <>
      <HistoryObat
        open={open.obat}
        setOpen={(val) => setOpen({ ...open, obat: val })}
      />
      <HistoryLaboratorium
        open={open.laboratorium}
        setOpen={(val) => setOpen({ ...open, laboratorium: val })}
      />
      <HistoryRadiologi
        open={open.radiologi}
        setOpen={(val) => setOpen({ ...open, radiologi: val })}
      />

      <Card
        elevation={0}
        // variant="outlined"
        sx={{
          padding: "24px 16px",
          borderRadius: "24px",
        }}
      >
        <Grid container spacing={1}>
          {[
            {
              title: "Farmasi",
              image: PillsImg,
              click: () => setOpen({ ...open, obat: true }),
            },
            {
              title: "Laboratorium",
              image: LabsImg,
              click: () => setOpen({ ...open, laboratorium: true }),
            },
            {
              title: "Radiologi",
              image: KneeXImg,
              click: () => setOpen({ ...open, radiologi: true }),
            },
          ].map((item, i) => {
            return (
              <Grid item xs>
                <ComponentPenunjang
                  title={item.title}
                  label={item.title}
                  image={item.image}
                  click={item.click}
                />
              </Grid>
            );
          })}
        </Grid>
      </Card>
    </>
  );
};

export default TemplatePenunjang;
